/**
 * Store Locator Slider (Reusable)
 * Wrap cards in [data-store-slider] — 3-col desktop, swipe + progress on mobile.
 */
document.addEventListener('DOMContentLoaded', function () {
  initStoreSliders();
});

function initStoreSliders() {
  document.querySelectorAll('[data-store-slider]').forEach(function (sliderWrap) {
    if (sliderWrap.dataset.swiperInit === 'true') return;

    const swiperEl = sliderWrap.querySelector('.swiper');
    const scrollbarEl = sliderWrap.querySelector('.store-locator__scrollbar');

    if (!swiperEl) return;

    new Swiper(swiperEl, {
      slidesPerView: 1.22,
      spaceBetween: 16,
      speed: 500,
      grabCursor: true,
      slidesPerGroup: 1,
      watchSlidesProgress: true,
      watchOverflow: true,
      scrollbar: {
        el: scrollbarEl,
        draggable: true,
        hide: false,
        snapOnRelease: true,
      },
      breakpoints: {
        992: {
          slidesPerView: 3,
          spaceBetween: 20,
          allowTouchMove: false,
        },
      },
    });

    sliderWrap.dataset.swiperInit = 'true';
  });
}